module.exports = __webpack_public_path__ + "files/de7a14d7ef7b0121e113b5f49418a4d4.png";